import * as React from 'react'
import './TextWithHighlights.scss'
import {useTranslation} from 'react-i18next'
import ExternalLink from '../Links/ExternalLink'
import PageComponent from './PageComponent'

type Highlight = {
    title: string
    text: string
    link?: string
}

type Props = {
    title: string
    description: string
    highlights: Array<Highlight>
    backgroundColor: string
}

const TextWithHighlights = ({title, description, highlights, backgroundColor}: Props) => {
    return (
        <PageComponent backgroundColor={backgroundColor}>
            <div className={'text-with-highlights'}>
                <div className={'text-with-highlights__text-wrapper'}>
                    <h2 className={'text-with-highlights__title'}>{title}</h2>
                    <h6 className={'text-with-highlights__description'}>{description}</h6>
                </div>
                <div className={'text-with-highlights__highlights'}>
                    {highlights.map((highlight) => (
                        <Highlight key={highlight.title} {...highlight} />
                    ))}
                </div>
            </div>
        </PageComponent>
    )
}

const Highlight = ({title, text, link}: Highlight) => {
    const {t} = useTranslation('')
    return (
        <div className={'text-with-highlights__highlight'}>
            <div className={'text-with-highlights__highlight__title'}>{title}</div>
            <div className={'text-with-highlights__highlight__text'}>{text}</div>
            {link && (
                <ExternalLink className={'text-with-highlights__highlight__link'} href={link}>
                    {t('commons-more')}
                </ExternalLink>
            )}
        </div>
    )
}

export default TextWithHighlights
